export const _115renxuanfushirenxuanfushirenxuanliu =  {
	balls:[
	    [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]
	],
    num:[
	    ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
    ],
    views:[
	    ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
    ],
    titles: [
	    '选6中5'
    ],
    chooseType:['全','大','小','奇','偶','清'],
    getLottery:(num,balls)=>{
        let str = ''; 
        for(let i = 0,len = balls.length;i < len;i++){
		    for(let l = 0,len_l = balls[i].length;l < len_l;l++){    
			    if(balls[i][l] > 0){
				    str += str?(' '+num[i][l]):num[i][l];
				}   
		    }
    	}
	    return str;
    },
    getNum:(balls)=>{
        let len_all=0,num = 0;
        for(let i=0,len=balls.length;i<len;i++){
            for(let j=0,len_j = balls[i].length;j<len_j;j++){
                if(balls[i][j]>0){
                    len_all++;
                }
            } 
        }
        if(len_all>=6){
            num = len_all*(len_all-1)*(len_all-2)*(len_all-3)*(len_all-4)*(len_all-5)/720;
        }
        return num;
    },
    getView: (views,balls)=>{
        let str = ''; 
        for(let i = 0,len = balls.length;i < len;i++){
            for(let l = 0,len_l = balls[i].length;l < len_l;l++){    
                if(balls[i][l] > 0){
                    str += str?(' '+views[i][l]):views[i][l];
                }   
            }
        }
        return str;
    }
}
